import { Space } from "antd"
import type { MenuProps } from "antd"
import { Dropdown } from "components/ui/dropdown/Dropdown"
import { ButtonOptions } from "components/ui/buttons/ButtonOptions/ButtonOptions"

type CompetitorDropdownProps = {
	items: MenuProps["items"]
}

export const CompetitorDropdown = ({ items }: CompetitorDropdownProps) => {
	return (
		<div onClick={(e) => e.stopPropagation()} data-testid="competitor-dropdown">
			<Dropdown items={items}>
				<Space>
					<ButtonOptions style={{ backgroundColor: "transparent" }} fillColor="#DEE0EB" />
				</Space>
			</Dropdown>
		</div>
	)
}
